import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of, shareReplay, tap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    public userInfo: any;
    private userInfo$: Observable<any> | null = null;
    private httpClient = inject(HttpClient);
    private router = inject(Router);
    getUserInfo() {
        return this.httpClient.get(`${environment.ALPHA_UI_AUTH_SERVICE_URL}/auth/user-info`).pipe(
            tap((userInfo) => {
                this.userInfo = userInfo;
            }),
            catchError((exception: HttpErrorResponse) => {
                if (exception.status == 401) {
                    if (exception?.error?.message === 'FORBIDDEN' || exception?.error?.error.message === 'FORBIDDEN') {
                        this.router.navigate(['unauthorized'], {
                            queryParams: { redirectUrl: encodeURIComponent(window.location.href) },
                        });
                        return of(null);
                    } else {
                        window.location.href = `${environment.ALPHA_UI_AUTH_SERVICE_URL}/auth/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
                    }
                }
                throw exception;
            }),
        );
    }

    getUser() {
        if (!this.userInfo$) {
            this.userInfo$ = this.getUserInfo().pipe(shareReplay(1));
        }
        return this.userInfo$;
    }

    logOut(path?: string) {
        window.location.href = `${environment.ALPHA_UI_AUTH_SERVICE_URL}/auth/logout?redirectUrl=${encodeURIComponent(path || window.location.href)}`;
    }
}

export interface UserGroupsResponse {
    groups: UserGroup[];
}

export interface PaginatedGroupsResponse {
    groups: UserGroup[];
    totalCount: number;
}

export interface UserGroup {
    id: number;
    group_name: string;
    client_id: string;
    inactive?: boolean;
}
